import { Injectable, EventEmitter, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HandleErrorService } from './handle-error.service';

import { APIURL } from 'src/environments/environment';
import { UserViewPermissions } from '../class/user-permissions';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {
  api = new APIURL();
  access = new UserViewPermissions();
  emitPermissions = new EventEmitter<UserViewPermissions>();
  // FIXME testar se participante responde a essa rota
  private info: any;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
    private handleErrorService: HandleErrorService
  ) {
    this.urlSessao(this.sessionService.role);
  }

  /*
    NOTE Interface de todos os módulos com permissionamento
    já cadastrados no sistema
  */
  readElements(): Observable<any> {
    const headers = this.api.headers;
    return this.http
      .get(this.api.url + '/api/acessoModuloFuncionalidade/modulos', {
        headers
      })
      .pipe(
        map(response => response),
        retry(3),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }

  /*
    NOTE Com base no token passado e pelo ID informado, retorna todos os acessos do
    usuario aquele módulo
  */
  readElementById(id: number): Observable<any> {
    const headers = this.api.headers;
    return this.http
      .get(
        this.api.url +
          '/api/acessoModuloFuncionalidade/modulos/' +
          id +
          '/funcionalidade',
        {
          headers
        }
      )
      .pipe(
        map(response => response),
        retry(3),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }

  /*
    NOTE Retorna um obj com todos os dados do usuário logado na sessão
    FIXME Rota '/api/participante/info' não estava funcionando durante esta aplicacao
  */
  readTokenData(): Observable<any> {
    const headers = this.api.headers;
    return this.http
      .get(this.api.url + this.info, {
        headers
      })
      .pipe(
        map(response => response),
        retry(3),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }

  /*
    NOTE Define quais permissoes o usuario tem acesso no sistema
  */
  setPermissions(id: number): any {
    this.readElementById(id).subscribe(
      res => {
        // NOTE Verifica se o obj nao esta vazio
        if (Object.keys(res).length) {
          res[0].funcionalidades.map(response => {
            switch (response) {
              case 'C':
                this.access.create = true;
                break;
              case 'R':
                this.access.read = true;
                break;
              case 'U':
                this.access.update = true;
                break;
              case 'D':
                this.access.delete = true;
                break;
              case 'ARQ':
                this.access.archive = true;
                break;
              case 'DARQ':
                this.access.unarchive = true;
                break;
              case 'CONV':
                this.access.invite = true;
                break;
            }
          });
          this.emitPermissions.emit(this.access);
        }
      },
      error => console.error(error)
    );
  }

  // Define qual variavel de ambiente será usada para buscar dados sessao
  urlSessao(role: any) {
    switch (role) {
      case 'ROLE_PARTICIPANTE':
        this.info = '/api/participante/mySelf/identificadores';
        break;
      case 'ROLE_COLABORADOR':
        this.info = '/api/colaborador/info';
        break;
      case 'ROLE_ESPECIALISTA':
        this.info = '/api/especialista/info';
        break;
      case 'ROLE_ADMIN':
        // NOTE Admin é um colaborador com mais privilégios
        this.info = '/api/colaborador/info';
        break;
    }
  }
}
